import { TFunction } from "i18next";

import { ICombinationRule } from "~/entity/CombinationRules";

import { combinationRulesTableColumns, getRuleCellText } from "./tableAdapter";

const escapeCell = (value: string): string =>
  /[";\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

const downloadCsv = (fileName: string, rows: string[][]) => {
  const content =
    "\uFEFF" + rows.map((row) => row.map(escapeCell).join(";")).join("\r\n");
  const url = window.URL.createObjectURL(
    new Blob([content], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Клиентская выгрузка в CSV текущей страницы справочника
 * (колонки и значения — как в таблице).
 */
export const exportCombinationRulesCsv = (
  t: TFunction,
  rules: ICombinationRule[],
  positionsMap: Map<number, string>,
) => {
  const header = combinationRulesTableColumns.map((column) =>
    t(`combinationRules.columns.${column}`),
  );
  const rows = rules.map((rule) =>
    combinationRulesTableColumns.map((column) =>
      getRuleCellText(t, rule, column, positionsMap),
    ),
  );

  downloadCsv("combination-rules.csv", [header, ...rows]);
};
